var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.25 11.25H12v5.25h.75","fill":"currentColor","key":1}),React.createElement("path",{"d":"M11.25 11.25H12v5.25h.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M12.875 7.875a1.063 1.063 0 1 1-2.125 0 1.063 1.063 0 0 1 2.125 0Z","fill":"currentColor","stroke":"currentColor","strokeWidth":".125","key":3})]);
}

Info.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Info;

Info.default = Info;
